'use strict';/* global define */define('modules/core/modules/dropdown/directives/dropdown-toggle/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
directive.$inject = ["esc"];
function directive(esc){return{restrict:'EA',require:'^^dropdown',link:function link(scope,element,attrs,ctrl){// jshint latedef:false
element.on('click',onClick);// ---
function onClick(ev){ev.preventDefault();scope.$evalAsync(ctrl.toggle);}}};}module.exports=directive;});
